/* src/app/global/components/global-help/global-help-documents/global-help-documents.component.scss */
:host ::ng-deep .mat-column-document-name,
:host .global-help-documents ::ng-deep phscw-documents-upload ::ng-deep .cw-selected-file .cw-document-name {
  margin: 0;
  width: 100%;
}
:host .hidden {
  height: 0;
  margin: 0;
  padding: 0;
  visibility: hidden;
}
/*# sourceMappingURL=global-help-documents.component.css.map */
